var Main = (function () {
  console.log('Main.js loaded');

  var Utility = window.Utility || {};

  var Acr = window.Acr || {};

  // Zipgate components
  const zipgateElement = document.getElementsByClassName('js-zipgate')[0];
  if (zipgateElement) {
    Acr.zipgateComponent = new Acr.Zipgate();
    Acr.zipgateComponent.init(zipgateElement);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Utility.log('DOMContentLoaded event fired');

    // Global Modules
    Acr.LazyLoadingHelper.init();
    Acr.DeferLoadingHelper.init();

    // New module Manager
    initializeModules();

    // Deprecated: call modules in this way is deprecated

    SlickOverride.init();

    Utility.enableActive();

    Acr.YouTubeManager.init();

    Acr.CampaignManager.init();

    WayPoints.init();

    SelectBox.init();

    Disclaimer.init();

    Acr.ShoppingTools.init();

    Acr.DeepLinking.init();

    Validation.init();

    Modals.init();

    Chart.init();

    FeatureModal.init();

    Acr.boxParallax.init();

    Acr.SignUpForEmails.init();

    TextSVGTiles.init();

    SearchCTA.init();

    RaqTool.initForms();

    RaqTool.initDealerInfo();

    RaqTool.initDisclaimers();

    OffersTool.init();

    FormEmailSignup.init();

    DealerLocatorTool.init();

    RequestBrochure.init();

    EmailSubscription.init();

    Acr.LanguageSelector.init();

  });

  // Expose the following variables and functions
  return {};
}());
